/* ============================================================
   ELGÄ — Smooth scroll maison (remplace Lenis)

   Pourquoi Lenis « cassait la molette » : base.css (Horizon) met
   html/body en overflow:hidden dès 990px et fait défiler la page
   DANS .page-wrapper. Lenis (et tout script visant window)
   interceptait la molette puis scrollait window… qui ne peut pas
   bouger → molette morte. Ici on détecte le scroller réel
   (.page-wrapper sur desktop, window sinon) à chaque molette.

   Seule la molette est lissée (wheel → interpolation
   exponentielle via rAF). Tactile, clavier, barre de défilement :
   100 % natifs. Si on ne peut pas prendre la main, on ne
   preventDefault pas → repli natif garanti.
   Désactivé : tactile, prefers-reduced-motion, éditeur de thème.
   ============================================================ */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  /* Tactile : momentum natif déjà fluide, on n'y touche pas */
  if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  var scroller = null;   /* élément scrollable actif ; null = window */
  var target = 0;
  var current = 0;
  var rafId = null;
  var animating = false;
  var stopped = false;
  var lastTime = 0;
  /* Constante de lissage : plus petit = inertie plus longue */
  var LAMBDA = 8;

  function detectScroller() {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight - pw.clientHeight > 1) {
      var o = getComputedStyle(pw).overflowY;
      if (o === 'auto' || o === 'scroll') return pw;
    }
    return null;
  }

  function getY() {
    return scroller ? scroller.scrollTop : window.scrollY;
  }
  function setY(y) {
    if (scroller) scroller.scrollTop = y;
    else window.scrollTo(0, y);
  }
  function getMax() {
    if (scroller) return Math.max(0, scroller.scrollHeight - scroller.clientHeight);
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  /* base.css pose scroll-behavior:smooth sur html et .page-wrapper :
     chaque étape rAF deviendrait une animation CSS → scroll gelé.
     On force l'instantané (nos ancres sont lissées par ce script). */
  function forceInstant() {
    document.documentElement.style.scrollBehavior = 'auto';
    var pw = document.querySelector('.page-wrapper');
    if (pw) pw.style.scrollBehavior = 'auto';
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceInstant);
  } else {
    forceInstant();
  }
  document.addEventListener('shopify:section:load', forceInstant);

  function loop(time) {
    var dt = (time - lastTime) / 1000;
    if (!(dt > 0)) dt = 0.016;
    if (dt > 0.05) dt = 0.05;
    lastTime = time;
    current += (target - current) * (1 - Math.exp(-LAMBDA * dt));
    if (Math.abs(target - current) < 0.5) {
      current = target;
      animating = false;
      rafId = null;
      setY(Math.round(current));
      return;
    }
    setY(Math.round(current));
    rafId = requestAnimationFrame(loop);
  }

  function startLoop() {
    if (animating) return;
    animating = true;
    lastTime = performance.now();
    rafId = requestAnimationFrame(loop);
  }

  function cancelLoop() {
    if (rafId) cancelAnimationFrame(rafId);
    rafId = null;
    animating = false;
  }

  /* Scroll venu d'ailleurs (clavier, barre, restauration…) :
     resynchronisation. Capture : les scrolls de .page-wrapper
     ne bubblent pas jusqu'à window. */
  document.addEventListener('scroll', function () {
    if (!animating) {
      current = target = getY();
    }
  }, { passive: true, capture: true });

  function normalizeDelta(e) {
    var d = e.deltaY;
    if (e.deltaMode === 1) d *= 33;
    else if (e.deltaMode === 2) d *= window.innerHeight;
    return d;
  }

  window.addEventListener('wheel', function (e) {
    if (stopped) return;                 /* drawer/menu ouverts : natif */
    if (e.ctrlKey) return;               /* zoom molette */
    if (e.defaultPrevented) return;
    /* Geste horizontal (trackpad, carrousels) : natif */
    if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) return;
    /* Zones scrollables internes (drawer panier, menu mobile) */
    if (e.target && e.target.closest && e.target.closest('[data-lenis-prevent]')) return;

    var s = detectScroller();
    if (!animating || s !== scroller) {
      scroller = s;
      current = target = getY();
    }
    var max = getMax();
    if (max <= 0) return;                /* rien à scroller → natif */

    e.preventDefault();
    target = Math.max(0, Math.min(max, target + normalizeDelta(e)));
    startLoop();
  }, { passive: false });

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--elga-header-h');
    var n = parseFloat(v);
    return isNaN(n) ? 0 : n;
  }

  var api = {
    stop: function () {
      stopped = true;
      cancelLoop();
      current = target = getY();
    },
    start: function () {
      stopped = false;
      current = target = getY();
    },
    scrollTo: function (dest) {
      scroller = detectScroller();
      current = getY();
      var y = typeof dest === 'number'
        ? dest
        : dest.getBoundingClientRect().top + current - headerOffset();
      target = Math.max(0, Math.min(getMax(), y));
      startLoop();
    }
  };

  /* Ancres lissées (équivalent Lenis anchors: true) */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('a[href*="#"]');
    if (!link || stopped) return;
    if (link.hostname !== window.location.hostname) return;
    if (link.pathname !== window.location.pathname) return;
    var id = decodeURIComponent(link.hash.slice(1));
    if (!id) return;
    var dest = document.getElementById(id);
    if (!dest) return;
    e.preventDefault();
    api.scrollTo(dest);
    if (history.pushState) history.pushState(null, '', '#' + id);
  });

  window.elgaSmooth = api;
  /* Compat : le thème appelle window.elgaLenis.stop()/start() */
  window.elgaLenis = api;
})();
